/**
 * Loads Intl polyfill data for a German based locale.
 * @param {string} locale - the German locale string to use.
 * @param {function} cb - the callback function to execute after loading the locale data.
 */
export default function loadGerman(locale, cb) {
  if (!global.IntlPolyfill) {
    cb();
    return;
  }
  const localeTokens = locale.replace('_', '-').split('-');
  switch (localeTokens[1] ? localeTokens[1].toUpperCase() : null) {
    case 'DE':
    default:
      require.ensure(['intl/locale-data/jsonp/de-DE'], require => {
        require('intl/locale-data/jsonp/de-DE');
        cb();
      });
  }
}
